/**
 * Lightweight Dynamic Data Replacement
 * Replaces [[cookie:name||fallback]] placeholders in elements with data-dynamic-data attribute
 */

(function () {
  /**
   * Get cookie value by name
   */
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(";").shift());
    }
    return null;
  }

  /**
   * Replace placeholders with cookie values
   * Supports: [[cookie:name||fallback]]
   */
  function replacePlaceholders(text) {
    return text.replace(
      /\[\[cookie:([^\]|]+)(?:\|\|([^\]]*))?\]\]/g,
      (_match, cookieName, fallback) => {
        const value = getCookie(cookieName.trim());
        return value !== null ? value : fallback || "";
      },
    );
  }

  /**
   * Process all elements with data-dynamic-data attribute
   */
  function processElements() {
    const elements = document.querySelectorAll("[data-dynamic-data]");

    elements.forEach((element) => {
      // Replace innerHTML if it contains the pattern
      if (element.innerHTML.includes("[[cookie:")) {
        element.innerHTML = replacePlaceholders(element.innerHTML);
      }
      // Always trigger fade-in animation
      setTimeout(() => {
        element.classList.add("dynamic-data-loaded");
      }, 1);
    });
  }

  // Run once on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", processElements);
  } else {
    processElements();
  }

  // Optional: expose function globally if you need to call it manually
  window.updateDynamicData = processElements;
})();
